import { SavedSearchCriteria } from '../types/savedSearch';
import { SAVED_SEARCH_NAME_MAX_LENGTH } from '../constants/savedSearchLimits';

// Maps the listing page's live filter state into saved-search criteria. The
// page's "no bound" sentinels must be dropped, not saved as real bounds:
// min 0, and BOTH unbounded-max forms — the initial-state default 1000000000
// AND the 999999999 the price-band select's "Any" / "£5,000,000+" options emit.

export interface ListingFilterState {
  region: string;
  strategy: string;
  propertyType: string;
  minValue: number;
  maxValue: number;
}

const PRICE_MIN_SENTINEL = 0;
const PRICE_MAX_UNBOUNDED_THRESHOLD = 999999999;

export function buildCriteriaFromListingFilters(
  filters: ListingFilterState
): SavedSearchCriteria {
  const criteria: SavedSearchCriteria = {};
  if (filters.region) criteria.region = filters.region;
  if (filters.propertyType) criteria.propertyType = filters.propertyType;
  if (filters.strategy) criteria.strategy = filters.strategy;
  if (filters.minValue !== PRICE_MIN_SENTINEL) criteria.minPrice = filters.minValue;
  if (filters.maxValue < PRICE_MAX_UNBOUNDED_THRESHOLD) criteria.maxPrice = filters.maxValue;
  return criteria;
}

// A short, editable default name for the capture modal — the strongest facets
// joined, a price fallback, then a generic fallback. Always within the API's
// 60-character name cap.
export function suggestListingSearchName(criteria: SavedSearchCriteria): string {
  const facets = [
    criteria.town || criteria.region,
    criteria.propertyType,
    criteria.strategy,
  ].filter(Boolean) as string[];
  let name = facets.join(' ');
  if (!name) {
    if (typeof criteria.maxPrice === 'number') {
      name = `Up to £${criteria.maxPrice.toLocaleString('en-GB')}`;
    } else if (typeof criteria.minPrice === 'number') {
      name = `£${criteria.minPrice.toLocaleString('en-GB')}+`;
    } else {
      name = 'My search';
    }
  }
  return name.slice(0, SAVED_SEARCH_NAME_MAX_LENGTH);
}
